import { Route } from "@angular/router";
import { DavParamListComponent } from "./dav-param-list.component";

export const DavParamListRouting : Route = {
    path: 'list',
    component: DavParamListComponent,
    data: {
        breadcrumb: "Liste"
    }
}
